import { createFileRoute } from '@tanstack/react-router';
import { AiChatThreadPage } from '@/pages/ai-assistant';

export const Route = createFileRoute('/_protected/ai-chat/chat/$threadId/')({
  component: AiChatThreadPage,
});
